import React, { useEffect } from "react";
import Nav from "@/components/site/Nav";
import Footer from "@/components/site/Footer";

export default function LegalPage({ title, lastUpdated, children, testId }) {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, []);

  return (
    <main className="bg-[#FDFCFB] text-[#1A1A1A] min-h-screen">
      <Nav />

      <section
        data-testid={testId}
        className="pt-32 md:pt-40 pb-16 md:pb-20 border-b border-[#E8E6E1]"
      >
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <div className="caption mb-6">Legal — Heritex Innovations Pvt. Ltd.</div>
          <h1 className="font-serif-display text-4xl sm:text-5xl md:text-6xl tracking-tight leading-[1.05] text-[#1A1A1A]">
            {title}
          </h1>
          {lastUpdated && (
            <p className="mt-6 caption">Last updated · {lastUpdated}</p>
          )}
        </div>
      </section>

      <article className="py-16 md:py-24">
        <div className="max-w-3xl mx-auto px-6 md:px-12 legal-prose">
          {children}
        </div>
      </article>

      <Footer />
    </main>
  );
}
